import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';


const paneStyle = () => css({
	width: '100%',
	padding: '1em',
    background: theme().palette.dimBackground,
	minHeight: 315,
});

const extendedPaneStyle = () => css(paneStyle(), {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'start',
	gap: '0.5em',
});


export function PreviewPane(P)
{
	return (
		<div class={paneStyle()}>
			{P.children}
		</div>
	);
}

/* Used for EventPage and SpecialPage, but not MenuItem */
export function ExtendedPreviewPane(P)
{
	return (
		<div class={extendedPaneStyle()}>
			{P.children}
		</div>
	);
}

